import React from 'react';

import type { EmbedNode } from './../../ricos-schema/next-schema';

import { HtmlViewer } from '../../plugin-html/viewer/html-viewer';
import type { LinkPreviewPluginEditorConfig } from '../types';

export const EmbedViewer: React.FC<{
  node: EmbedNode;
  settings: LinkPreviewPluginEditorConfig;
  iframeSandboxDomain: string;
}> = ({ node, settings, iframeSandboxDomain }) => {
  const htmlCompProps = {
    htmlData: {
      ...node.embedData,
      html: unescape(node.embedData.oembed?.html ?? ''),
    },
    settings,
    iframeSandboxDomain,
  };
  return <HtmlViewer {...htmlCompProps} />;
};
